var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['status-label', 'invoice', _vm.statusName, _vm.size]},[_c('span',{staticClass:"text"},[_c('span',[_vm._v(_vm._s(_vm.statusTxt))]),(_vm.count !== null)?_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }